module.exports = __webpack_public_path__ + "assets/img/floor-slope.fe01c1ae.webp";